import React from 'react';
import '../../assets/scss/projectTable.scss';
import { ReactComponent as LinkIcon } from '../../assets/svg/external-link.svg';

import moment from 'moment';

import _ from 'lodash';

class ProjectListTableRow extends React.Component {
	constructor() {
		super();
		this.state = {
			search: false,
			//showDetailProjectModal: false,
		};
	}

	showDetailProjectModal = (e) => {
		this.props.history.push(`projects/project/${this.props.data.id}`);
	};

	goToShoot = (e, workspaceID, projectID, shootID) => {
		this.props.navigate(
			`/${this.props.params.vendorID}/shoots/${workspaceID}/${projectID}/${shootID}`,
		);
	};
	getWorkspacekey = (name) => {
		if (this.props.workspacesFilters.length !== 0) {
			for (let i = 0; i < this.props.workspacesFilters.length; i++) {
				if (this.props.workspacesFilters[i].name === name) {
					return this.props.workspacesFilters[i].workspaceKey;
				}
			}
		}
		return ' ';
	};
	render() {
		return (
			<tr
				height={40}
				onClick={() => {
					this.props.navigate(
						`/${this.props.params.vendorID}/equipments/${this.props.data.qrCode}`,
					);
				}}
			>
				<td
					style={{
						fontSize: '14px',
						borderLeft: '0.5px solid  #383838',
						borderRight: '0.5px solid  #383838',
						borderLeftRadius: '12px',
					}}
					onClick={() => this.props.handleRowClick()}
				>
					<div
					// style={{
					//     height: '100%',
					//     position: 'relative',
					// }}
					>
						<span>{this.props.data.qrCode}</span>

						{/* <div className="lower-wed">
							{this.props.data.workspaceDetails.workspaceKey}
						</div> */}
					</div>
				</td>
				<td
					style={{
						fontSize: '14px',
						borderRight: '0.5px solid  #383838',
					}}
					// className="all-other-column-fixed"
					onClick={() => this.props.handleRowClick()}
				>
					<p>{this.props.data.description}</p>
					<p
						style={{
							color: '#707070',
							marginTop: '8px',
						}}
					>
						{this.props.data.manufacturerId}
					</p>
				</td>
				<td
					style={{
						fontSize: '14px',
						borderRight: '0.5px solid  #383838',
					}}
					// className="all-other-column-fixed"
					onClick={() => this.props.handleRowClick()}
				>
					<p>
						{' '}
						{this.props.data.type.replace(/^[a-z]|[A-Z]/g, function (v, i) {
							return i === 0 ? v.toUpperCase() : ' ' + v.toLowerCase();
						})}
					</p>
				</td>

				<td
					style={{
						fontSize: '14px',
						borderRight: '0.5px solid  #383838',
					}}
					// className="all-other-column-fixed"
					onClick={() => this.props.handleRowClick()}
				>
					<span
						className={`completed-shoots `}
						style={{
							// marginTop: '-120px',

							display: 'flex',
							// justifyContent: 'flex-start',
							alignItems: 'center',
							textTransform: 'uppercase',
							fontSize: '14px',
						}}
					>
						<b
							style={{
								width: '10px',
								height: '10px',
								minHeight: '10px',
								minWidth: '10px',
								borderRadius: '2px',
								backgroundColor:
									this.props.data.status === 'ready' ? '#479A5F' : '#CA5A4F',
								marginRight: 5,
								display: 'flex',
							}}
						></b>
						{this.props.data.status === 'ready' ? 'READY' : 'BUSY'}

						{/* <p>{this.props.data.status}</p> */}
					</span>
				</td>
				<td
					style={{
						fontSize: '14px',
						borderRight: '0.5px solid  #383838',
					}}
					// className="all-other-column-fixed"
					onClick={() => this.props.handleRowClick()}
				>
					{this.props.data.lastUsedBy !== null && this.props.data.status === 'busy' ? (
						<div>
							<p>
								{'(' +
									this.getWorkspacekey(this.props.data.lastUsedBy.workspaceId) +
									')'}
								{this.props.data.lastUsedBy.projectName
									? this.props.data.lastUsedBy.projectName
									: ''}
							</p>
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									gap: '5px',
								}}
							>
								<p
									style={{
										color: '#B0B0B0',
										marginTop: '8px',
									}}
								>
									{this.props.data.lastUsedBy.eventName
										? this.props.data.lastUsedBy.eventName
										: ''}
								</p>
								{this.props.data.lastUsedBy !== null ? (
									<span
										className="external-link"
										onClick={(e) => {
											e.stopPropagation();
											this.goToShoot(
												e,
												this.props.data.lastUsedBy.workspaceId,
												this.props.data.lastUsedBy.projectId,
												this.props.data.lastUsedBy.eventId,
											);
										}}
									>
										<LinkIcon style={{ marginTop: '10px' }} />
									</span>
								) : null}
							</div>
						</div>
					) : (
						<div className="project-general-box">
							<span
								className="black-amount-number-text"
								style={{ textTransfrom: 'capitalize' }}
							></span>
						</div>
					)}
				</td>
				<td
					style={{
						fontSize: '14px',
						borderRight: '0.5px solid  #383838',
					}}
					onClick={() => this.props.handleRowClick()}
				>
					{this.props.data.lastUsedBy !== null && this.props.data.status === 'busy' ? (
						<div>
							<p> {this.props.data.lastUsedBy.userName}</p>

							{this.props.data.lastUsedBy !== null &&
							this.props.data.lastUsedBy.usedAt !== null ? (
								<div
									style={{
										color: '#707070',
										marginTop: '8px',
									}}
								>
									{moment
										.unix(this.props.data.lastUsedBy.usedAt)
										.format('DD MMM YYYY, h:mma')}
								</div>
							) : (
								''
							)}
						</div>
					) : (
						<div>
							<span style={{ textTransfrom: 'capitalize' }}></span>
						</div>
					)}
				</td>
			</tr>
		);
	}
}

export default ProjectListTableRow;
